import { useEffect, useState } from "react";
import "./theme.css";

const card = {
  border: "1px solid var(--audit-border)",
  borderRadius: 8,
  background: "var(--audit-bg-subtle)",
  padding: "12px 14px",
  marginBottom: 14,
};
const h3 = { fontSize: 14, fontWeight: 800, margin: "0 0 8px" };
const li = { fontSize: 13, lineHeight: 1.9 };
const pill = {
  fontSize: 12.5,
  padding: "5px 11px",
  border: "1px solid var(--audit-border)",
  borderRadius: 12,
  color: "var(--audit-accent)",
  textDecoration: "none",
};

export default function InstallmentPage() {
  const [d, setD] = useState(null);

  useEffect(() => {
    fetch("/api/onto/installment")
      .then((r) => r.json())
      .then(setD)
      .catch(() => setD({}));
  }, []);

  const links = d?.links || {};

  return (
    <div
      className="audit-root"
      style={{
        height: "100%",
        overflow: "auto",
        background: "var(--audit-bg)",
        padding: "18px 22px",
      }}
    >
      <div style={{ maxWidth: 820 }}>
        <h2 style={{ fontSize: 17, fontWeight: 800, margin: "0 0 4px" }}>
          관세 분할납부 (관세법 제107조)
        </h2>
        <div
          style={{
            fontSize: 12.5,
            color: "var(--audit-text-muted)",
            marginBottom: 14,
          }}
        >
          납부기한 내 일시 납부가 곤란하거나, 특정 물품·기관이 수입하는 물품에 대해 관세를
          나누어 납부하도록 승인하는 제도.
        </div>

        {d === null ? (
          <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
            불러오는 중…
          </div>
        ) : !d.types ? (
          <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
            데이터를 불러오지 못했습니다.
          </div>
        ) : (
          <>
            {/* 유형 카드 2개 */}
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
              {(d.types || []).map((t, i) => (
                <div
                  key={i}
                  style={{
                    flex: "1 1 320px",
                    border: "1px solid var(--audit-border)",
                    borderRadius: 8,
                    padding: "12px 14px",
                    background: "var(--audit-bg)",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                    <span style={{ fontSize: 14, fontWeight: 800 }}>{t.title}</span>
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        padding: "1px 7px",
                        borderRadius: 10,
                        background: "var(--audit-accent-bg)",
                        color: "var(--audit-accent)",
                      }}
                    >
                      {t.period}
                    </span>
                  </div>
                  <div style={{ fontSize: 12.5, lineHeight: 1.7, color: "var(--audit-text)" }}>
                    {t.desc}
                  </div>
                </div>
              ))}
            </div>

            {/* 정책적 분할납부 대상 */}
            <div style={card}>
              <div style={h3}>정책적 분할납부 대상 (5년 이내)</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(d.policyTargets || []).map((c, i) => (
                  <li key={i} style={li}>
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            {/* 사후관리 */}
            <div style={card}>
              <div style={h3}>사후관리 · 유의사항</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(d.postManagement || []).map((c, i) => (
                  <li key={i} style={li}>
                    {c}
                  </li>
                ))}
              </ul>
              <div
                style={{
                  fontSize: 11.5,
                  color: "var(--audit-text-faint)",
                  marginTop: 8,
                }}
              >
                ※ {d.note}
              </div>
            </div>

            {/* 근거·도구 */}
            <div
              style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}
            >
              {links.customs && (
                <a
                  href={links.customs}
                  target="_blank"
                  rel="noreferrer"
                  style={{ ...pill, borderColor: "var(--audit-accent)", fontWeight: 600 }}
                >
                  관세청 — 분할납부 안내 ↗
                </a>
              )}
              {links.law && (
                <a href={links.law} target="_blank" rel="noreferrer" style={pill}>
                  law.go.kr — 관세법 제107조 ↗
                </a>
              )}
              {links.rule && (
                <a href={links.rule} target="_blank" rel="noreferrer" style={pill}>
                  law.go.kr — 관세법 시행규칙 ↗
                </a>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
